import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../../../ui/dialog";

function displayDateFromTimestamp(ts: string) {
  // moment(activityLastUpdatedDate).fromNow() always shows in English, need to localize if we will use it
  const d = new Date(ts);
  const year = d.getFullYear();
  const yearText = String(year).padStart(4, "0");
  const month = d.getMonth();
  const monthText = String(month).padStart(2, "0");
  const dayOfMonth = d.getDate();
  const dayOfMonthText = String(dayOfMonth).padStart(2, "0");
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    !Number.isInteger(dayOfMonth)
  ) {
    return null;
  }
  return `${yearText}-${monthText}-${dayOfMonthText}`;
}

function WorkflowInfoDialog({
  showWorkflowInfoDialog,
  setShowWorkflowInfoDialog,
  activityLastUpdatedDate,
  prescriptionVersionNo,
  activityMetadata,
  userInfo,
}: any) {
  const { t } = useTranslation();

  function authorLetters() {
    if (activityMetadata?.vendor?.displayName) {
      return activityMetadata?.vendor?.displayName.split(" ")[0];
    }
    if (activityMetadata?.fiUser?.email) {
      return activityMetadata?.fiUser?.email.split("@")[0];
    }
    return "?";
  }

  function authorName() {
    if (activityMetadata?.vendor?.displayName) {
      return (<span>{activityMetadata.vendor.displayName}</span>)
    } else if (activityMetadata?.fiUser?.email) {
      return (<span>{activityMetadata.fiUser.email}</span>)
    } else {
      return (<span>Unknown</span>)
    }
  }

  function vendorPageLink() {
    if (activityMetadata?.vendor?._id) {
      return (
        <Link to={`/marketplace/vendor/${activityMetadata.vendor._id}`} >Learn more</Link>
      );
    } else {
      return (<span></span>)
    }
  }

  return (
    <Dialog
      open={showWorkflowInfoDialog}
      onOpenChange={setShowWorkflowInfoDialog}
    >
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>{t("title_about_this_activity")}</DialogTitle>
        </DialogHeader>

        <div className="space-y-6">
          {/* Author Section */}
          <div className="space-y-3">
            <h3 className="text-sm font-medium">{t("label_created_by")}</h3>
            <div className="flex items-start gap-3">
              <div className="h-8 w-8 rounded-full overflow-hidden">
                <img
                  src={`https://ui-avatars.com/api/?name=${authorLetters()}`}
                  alt="Avatar"
                />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h4 className="font-medium">{authorName()}</h4>
                  <p>{vendorPageLink()}</p>
                  {/* <Button variant="ghost" size="sm" className="h-6 px-2">
                    <ExternalLink className="h-3 w-3" />
                  </Button> */}
                </div>
                {/* <p className="text-sm text-muted-foreground">
                  {mockAuthor.bio}
                </p> */}
              </div>
            </div>
          </div>

          {/* Workflow Details Section - Placeholder for future expansion */}
          <div className="space-y-3">
            <h3 className="text-sm font-medium">{t("activity_details")}</h3>
            <div className="space-y-2 text-sm">
              {/*
              <div className="flex justify-between">
                <span className="text-muted-foreground">{t("label_version")}</span>
                <span>{prescriptionVersionNo || "N/A"}</span>
              </div>
              */}
              <div className="flex justify-between">
                <span className="text-muted-foreground">
                  {t("label_published")}
                </span>
                <span>
                  {displayDateFromTimestamp(activityLastUpdatedDate) ??
                    t("unknown")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default WorkflowInfoDialog;
